module.exports = __webpack_public_path__ + "static/media/logo-voxar-footer.13b46b1b.png";